import { getHandler } from "./components/live_table/actions";

function getRowData(): Record<string, any> {
  const el = document.getElementById("change-form-row-data");
  if (el?.textContent) {
    return JSON.parse(el.textContent);
  }
  const match = window.location.pathname.match(/\/(\d+)\/change\/?$/);
  return { pk: match ? parseInt(match[1], 10) : undefined };
}

export function initChangeFormActions() {
  const row = getRowData();

  document.querySelectorAll<HTMLButtonElement>("[data-handler]").forEach((btn) => {
    if (btn.closest("#live-table-root")) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const handlerName = btn.dataset.handler!;
      const config = btn.dataset.handlerConfig
        ? JSON.parse(btn.dataset.handlerConfig)
        : {};
      const handler = getHandler(handlerName);
      handler({
        source: "change_form",
        actionName: handlerName,
        selectedRows: [row],
        optionValues: {},
        config,
      });
    });
  });
}
